export default __webpack_public_path__ + "static/media/the-core-element.24877b0a.svg";